import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Modal from 'modules/common/components/Modal';
import withForm from 'modules/common/hoc/withForm';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import { omitEmptyArgs } from 'helper';
import PropTypes from 'prop-types';
import * as actions from '../action';

function BuildingMaterialTypeModal({
  createBuildingMaterialType,
  type,
  dataInfo,
  updateBuildingMaterialType,
  history,
  getBuildingMaterialTypeList,
  getSingleMaterialType,
  id,
}) {
  
  const setModal = useContext(ModalContext);

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    is_active: 0
  });

  const validateForm = useFormValidator(formData, {
    name: 'required',
    description: 'required',
  });

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (type === 'NEW') {
      createBuildingMaterialType(omitEmptyArgs(formData), (data) => {
        setModal({ isOpen: false });
        getBuildingMaterialTypeList();
        history.push(`/rpt/building/settings/building-materials/${data.data.id}`);
        getSingleMaterialType(data.data.id);
      });
    }

    if (type === 'EDIT') {
      updateBuildingMaterialType(id, omitEmptyArgs(formData), (data) => {
        setModal({ isOpen: false });
        getBuildingMaterialTypeList();
        history.push(`/rpt/building/settings/building-materials/${data.data.id}`);
        getSingleMaterialType(data.data.id);
      });
    }
  };

  const handleOnClose = (e) => {
    if (e) e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    if (type === 'EDIT') {
      setFormData({
        ...formData,
        name: _.get(dataInfo, 'name'),
        description: _.get(dataInfo, 'description'),
        is_active: _.get(dataInfo, 'is_active'),
      });
    }
  }, []);

  const onChange = (e) => {
    const isChecked = e.target.checked ? 1 : 0;
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? isChecked : e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className='col-12 form-group'>
            <label htmlFor="last_name" className="form-label mb-0">
              Material Name &nbsp;{' '}
              {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name') || ''}
            />
          </div>
          <div className='col-12 form-group'>
            <label htmlFor="last_name" className="form-label mb-0">
              Description &nbsp;{' '} {validateForm.renderMessage('description')}
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Is Active: &nbsp;
            </label>
            <input
              name="is_active"
              type="checkbox"
              checked={_.get(formData, 'is_active')}
              onChange={onChange}
            />
          </div>
        </div>
        <hr className="below-hr" />
        <div className="d-flex justify-content-center">
          <button
            type="button"
            onClick={handleOnClose}
            className="mt-3 btn btn-dark mr-3"
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

BuildingMaterialTypeModal.defaultProps = {
  type: '',
  dataInfo: {},
  id: '',
};

BuildingMaterialTypeModal.propTypes = {
  createBuildingMaterialType: PropTypes.instanceOf(Function).isRequired,
  updateBuildingMaterialType: PropTypes.instanceOf(Function).isRequired,
  type: PropTypes.string,
  id: PropTypes.string,
  history: PropTypes.instanceOf(Object).isRequired,
  dataInfo: PropTypes.instanceOf(Object),
  getBuildingMaterialTypeList: PropTypes.instanceOf(Function).isRequired,
  getSingleMaterialType: PropTypes.instanceOf(Function).isRequired,

};

const mapStateToProps = () => ({
});

const enhance = _.flowRight([
  withRouter,
  withForm,
  connect(mapStateToProps, actions),
]);

export default enhance(BuildingMaterialTypeModal);
